module.exports = __webpack_public_path__ + "static/media/appstore_fr.2cfdd0a7.svg";